import { Injectable } from '@angular/core';

import { TreeNode } from '@mirage-projects/cw-models';

@Injectable({ providedIn: 'root' })
export class TreeviewService {
    nodeEditing: TreeNode | null = null;
    oldName = '';

    /**
     * Updates the child nodes checked state depending the current node state
     * If the current node has been checked, all the active child nodes will be also checked
     * @param treeNode node structure to set the checked state
     * @param enabled indicates if the checked state has to be set or unset
     */
    updateChildCheckedState(treeNode: TreeNode | undefined, enabled = false): void {
        if (!treeNode) {
            return;
        }

        treeNode.checked = enabled && !treeNode.inactive;

        treeNode.children.forEach((item: any) => {
            this.updateChildCheckedState(item, enabled);
        });
    }

    /**
     * Clear the current node selection
     * @param data Node to clear
     */
    clearSelection(data: TreeNode): void {
        data.selected = false;

        data?.children?.forEach((child) => {
            this.clearSelection(child);
        });
    }

    /**
     * take the node selected and makes it editable
     * @param node
     */
    enableEditing(node: TreeNode): void {
        if (node.isEditable) {
            this.oldName = node.title;
            this.nodeEditing = node;
        }
    }
}
